import React from 'react';
import { T } from '../traks';
import BigText from '../c/BigText';
import { site_base } from '../Site';

function PrivacyPolicyOld(props) {
	return (
		<div className="container ad_privacy_policy p-4">
			<T context="privacy_policy" deps={[site_base]}>
			__PRIVACY_POLICY_BIG_CHUNK__
			</T>
		</div>
	);
}

function PrivacyPolicyBT(props) {
	return (
		<div className="container ad_privacy_policy p-4">
			<BigText k="privacy_policy" fallback_lang="da"/>

		</div>
	);
}

function PrivacyPolicy(props) {
	return IS_AKTIEDYSTEN_DK ? <PrivacyPolicyBT/> : <PrivacyPolicyOld/>;
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/p/PrivacyPolicy.js